import L from 'leaflet';
import cycloneSvg from './hazardIcons/cyclone.svg?raw';
import floodSvg from './hazardIcons/flood.svg?raw';
import earthquakeSvg from './hazardIcons/earthquake.svg?raw';
import { hazardMarkup, HAZARD_ICON_SIZE_PX } from './hazardMarkup';

export const HAZARD_SVG = {
  cyclone: cycloneSvg,
  flood: floodSvg,
  earthquake: earthquakeSvg,
};

// Glyphs have no tip, so the icon is centred on the event position. The
// accessible name lives on the Marker (title), not in these shared icons.
const half = HAZARD_ICON_SIZE_PX / 2;
const HAZARD_ICONS = Object.fromEntries(
  Object.entries(HAZARD_SVG).map(([type, svg]) => [
    type,
    L.divIcon({
      className: 'leaflet-pin-icon hazard-icon',
      html: hazardMarkup(svg),
      iconSize: [HAZARD_ICON_SIZE_PX, HAZARD_ICON_SIZE_PX],
      iconAnchor: [half, half],
      popupAnchor: [0, -half],
    }),
  ]),
);

/** Returns the shared icon for a hazard type, or null so callers skip the marker. */
export function getHazardIcon(type) {
  return Object.hasOwn(HAZARD_ICONS, type) ? HAZARD_ICONS[type] : null;
}
